import ecommerceReducer from "legacy/reducers/ecommerceReducer";
import appSettings from "legacy/reducers/appSettings";

const legacyReducers = {
  ecommerce: ecommerceReducer,
  appSettings,
};

export default legacyReducers;
